var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CBEBFE41-37DB-4A3B-AA3F-82148AFCC5A7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Essetional---Bold",
    transform: "translate(-364.000000, -380.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cup",
    transform: "translate(364.000000, 380.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,18.2509375 C7.89999998,18.2509375 7,19.1509374 7,20.2509375 L7,20.5009375 L6,20.5009375 C5.59,20.5009375 5.25,20.8409375 5.25,21.2509375 C5.25,21.6609375 5.59,22.0009375 6,22.0009375 L18,22.0009375 C18.41,22.0009375 18.75,21.6609375 18.75,21.2509375 C18.75,20.8409375 18.41,20.5009375 18,20.5009375 L17,20.5009375 L17,20.2509375 C17,19.1509374 16.1,18.2509375 15,18.2509375 L12.75,18.2509375 L12.75,15.9609375 C12.5,15.9909375 12.25,16.0009375 12,16.0009375 C11.75,16.0009375 11.5,15.9909375 11.25,15.9609375 L11.25,18.2509375 L9,18.2509375 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1792965,10.5200005 C21.1092965,9.49000049 21.7192955,8.26000023 21.7192955,6.82000017 C21.7192955,5.38000011 20.5892959,4.25 19.1492958,4.25 L18.5892963,4.25 C17.9392964,2.91999996 16.5792972,2 14.9992971,2 L8.99929714,2 C7.4192971,2 6.05929673,2.91999996 5.40929675,4.25 L4.84929681,4.25 C3.40929675,4.25 2.27929688,5.38000011 2.27929688,6.82000017 C2.27929688,8.26000023 2.88929683,9.49000049 3.81929684,10.5200005 C4.27929688,10.9800005 4.85929686,11.3900003 5.51929688,11.6400003 C6.55929685,14.2000003 9.05929708,16 11.9992971,16 C14.9392972,16 17.4392958,14.2000003 18.4792957,11.6400003 C19.1392958,11.3900003 19.7192965,10.9800005 20.1792965,10.5200005 Z M14.2192974,9.21000004 C14.1192974,9.32000004 14.0492976,9.53999957 14.0592976,9.68999958 L14.119297,10.6700001 C14.159297,11.2700001 13.7292972,11.5799997 13.1692972,11.3599997 L12.2592974,11 C12.1192974,10.95 11.8792969,10.95 11.7392969,11 L10.8292971,11.3599997 C10.2692971,11.5799997 9.83929726,11.2700001 9.87929726,10.6700001 L9.93929672,9.68999958 C9.94929672,9.53999957 9.87929688,9.32000004 9.77929688,9.21000004 L9.15929699,8.44999981 C8.769297,7.9899998 8.93929762,7.47999993 9.5192976,7.32999992 L10.4692974,7.09000015 C10.6192974,7.05000015 10.7992973,6.91000021 10.8792973,6.78000021 L11.409297,5.96000004 C11.739297,5.45000005 12.2592973,5.45000005 12.5892973,5.96000004 L13.119297,6.78000021 C13.199297,6.91000021 13.3792969,7.05000015 13.5292969,7.09000015 L14.4792967,7.32999992 C15.0592967,7.47999993 15.2292973,7.9899998 14.8392973,8.44999981 L14.2192974,9.21000004 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0,
    transform: "translate(12.000000, 12.000000) rotate(-180.000000) translate(-12.000000, -12.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldCup);
export default __webpack_public_path__ + "static/media/vuesax-bold-cup.b4f8087b9472e74836a43cc20e5bcb2d.svg";
export { ForwardRef as ReactComponent };